import GenericResultView from './GenericResultView';

export default GenericResultView;
